import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getOpenItemsByTaskId,
  getSelectedOpenItemId,
} from '../../../../selectors/admin/work-orders/details/details';
import Date from '../../../shared/text/Date';
import SimpleTable from '../../../shared/table/SimpleTable';
import numeral from 'numeral';
import './DetailsOpenItems.css';
import EditOpenItemModal from './open-items/EditOpenItemModal';
import { setSelectedOpenItem } from '../../../../actions/admin/work-orders/details/details';
import SimpleTruncate from '../../../shared/text/SimpleTruncate';

class DetailsOpenItems extends Component {
  render() {
    return (
      <div className="details-open-items">
        <SimpleTable
          className="open-items-table"
          headers={[
            'TASK #',
            'ASSIGNED TO',
            'STATUS',
            'DESCRIPTION',
            'NOTE',
            'UPDATED AT',
            'CRITICAL',
          ]}
          rows={DetailsOpenItems.mapOpenItems(this.props.openItemsByTaskId)}
          emptyMessage="No Open Items"
          onRowSelected={this.handleOpenItemSelection}
        />

        {this.props.selectedOpenItemId !== null && (
          <EditOpenItemModal
            taskId={this.taskId}
            taskNumber={this.taskNumber}
          />
        )}
      </div>
    );
  }

  handleOpenItemSelection = (openItemId) => {
    const openItems = Object.values(this.props.openItemsByTaskId).reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue),
      []
    );
    const openItem = openItems.find((openItem) => openItem.id === openItemId);

    this.taskId = openItem.task.id;
    this.taskNumber = openItem.task.number;
    this.props.dispatch(setSelectedOpenItem(openItem));
  };

  static mapOpenItems(openItemsByTaskId) {
    const openItems = Object.values(openItemsByTaskId).reduce(
      (accumulator, currentValue) => accumulator.concat(currentValue),
      []
    );

    return openItems.map((openItem) => {
      return {
        id: openItem.id,
        selectable: true,
        data: [
          `${numeral(openItem.task.number).format('00')}-${openItem.letter}`,
          `${openItem.user.first_name} ${openItem.user.last_name}`,
          DetailsOpenItems.createStatusElement(openItem.resolved),
          openItem.description,
          openItem.resolved_note !== null ? (
            <SimpleTruncate text={openItem.resolved_note} />
          ) : (
            'N/A'
          ),
          <Date value={openItem.updated_at} format="LL" />,
          openItem.critical ? 'Yes' : 'No',
        ],
      };
    });
  }

  static createStatusElement(resolved) {
    return (
      <div className="status-container">
        <span>{resolved ? 'Complete' : 'Incomplete'}</span>
        <div className={`status ${resolved ? 'complete' : 'incomplete'}`} />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    openItemsByTaskId: getOpenItemsByTaskId(state),
    selectedOpenItemId: getSelectedOpenItemId(state),
  };
})(DetailsOpenItems);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/DetailsOpenItems.js